import React, { useEffect, useState } from 'react';
import Button from '../../../../components/Button';
import { Box, Checkbox, Container, Grid, IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateIcon from '@mui/icons-material/Create';
import { useTheme } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';
import { useQuestionBank } from '../../../questionBank/hooks';
import { QuestionPagination } from '../../../../components/questionBank/Pagination';
import PreviewQuestion from './PreviewQuestion';
import { Eye, SmileySad, X } from '@phosphor-icons/react';
import { stormGrey } from '../../../../theme/colors';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles()((theme) => ({
    headerText: {
        textAlign: 'left',
        color: theme.palette.primary.blue,
        margin: '0',
        fontWeight: '700',
        lineHeight: '1.5',
        fontSize: '2rem',
    },
    headerText2: {
        textAlign: 'center',
        color: 'white',
        margin: '0',
        fontWeight: '700',
        lineHeight: '1.5'
    },
    headerCell: {
        margin: '0',
        fontWeight: '700',
        lineHeight: '1.5',
        textAlign: 'center'
    },
    actionBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        height: '80%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: 24,
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    modalContent: {
        flex: 1,
        overflow: 'auto',
        padding: theme.spacing(4),
    },
    closeBtn: {
        position: 'absolute',
        top: 8,
        right: 8,
    }
}));

export const ManageQuestions = ({ handleClose, handleCheckboxChange, selectedQuestions, setModalType, setQuestionId, chapterId, sectionId, onQuestionUpdated }) => {

    const theme = useTheme();
    const { courseId } = useParams();
    const { classes } = useStyles();
    const { remove, courseQuestions, loadCourseQuestions, pagination } = useQuestionBank();
    const [questions, setQuestions] = useState();
    const [openPreview, setOpenPreview] = useState(false);
    const [previewData, setPreviewData] = useState();

    const filterDetails = { courseId, sectionId, chapterId };

    useEffect(() => {
        if (chapterId && sectionId) {
            loadCourseQuestions({ courseId: courseId, sectionId: sectionId, chapterId: chapterId })
        } else if (courseId && sectionId) {
            loadCourseQuestions({ courseId: courseId, sectionId: sectionId })
        } else {
            loadCourseQuestions({ courseId: courseId })
        }
    }, [courseId, sectionId, chapterId]);

    useEffect(() => {
        if (courseQuestions) {
            setQuestions(courseQuestions)
        }
    }, [courseQuestions]);

    const handleEdit = (id) => {
        setQuestionId(id)
        setModalType('create')
    }

    const handleDelete = (id) => {
        if (!confirm('Are you sure to delete this question?')) { return; }
        remove({ id: id, isQuestionBank: false });
    }
    const handleModel = (question) => {
        setPreviewData(question);
        setOpenPreview(!openPreview);
    }

    const handlePreviewClose = () => {
        setPreviewData({});
        setOpenPreview(!openPreview)
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <div className='course header-container'>
                    <div className='header'>
                        <Typography className={classes.headerText} variant="h1">Manage Questions</Typography>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12}>
                {questions && questions?.data?.length > 0 ? (
                    <>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="questions table">
                                <TableHead >
                                    <TableRow>
                                        <TableCell className={classes.headerCell} variant="h6" color="primary.blue">Select</TableCell>
                                        <TableCell className={classes.headerCell} variant="h6" color="primary.blue">Question</TableCell>
                                        <TableCell className={classes.headerCell} variant="h6" color="primary.blue">Type</TableCell>
                                        <TableCell className={classes.headerCell} variant="h6" color="primary.blue">Marks</TableCell>
                                        <TableCell className={classes.headerCell} variant="h6" color="primary.blue">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {questions?.data?.map((question, index) => {
                                        const isChecked = selectedQuestions.some(q => q.id === question.id);
                                        return (
                                            <TableRow key={question.id}>
                                                <TableCell align='center'>
                                                    <Checkbox
                                                        checked={isChecked}
                                                        size="medium"
                                                        onChange={() => handleCheckboxChange(question)}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">{question?.questionDetails?.text || ''}</TableCell>
                                                <TableCell align="center">{question?.type}</TableCell>
                                                <TableCell align="center">{question?.answerDetails?.options?.marks}</TableCell>
                                                <TableCell align="center" >
                                                    <Box className={classes.actionBox}>
                                                        <IconButton title='Edit' onClick={() => handleEdit(question.id)}>
                                                            <CreateIcon sx={{ color: theme.palette.primary.blue, fontSize: '1.2rem' }} />
                                                        </IconButton>
                                                        <IconButton title='Preview' onClick={() => handleModel(question)}>
                                                            <Eye style={{ color: theme.palette.primary.blue, fontSize: '1.2rem' }} />
                                                        </IconButton>
                                                        <IconButton title='Delete' onClick={() => handleDelete(question?.id)}>
                                                            <DeleteIcon sx={{ color: theme.palette.primary.red, fontSize: '1.2rem' }} />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid item xs={12} style={{ marginTop: '1rem' }}>
                            <QuestionPagination filterDetails={filterDetails} />
                        </Grid>
                    </>
                ) : (
                    <Container style={styles.container}>
                        <div style={styles.row}>
                            <div style={styles.iconContainer}>
                                <SmileySad size={32} />
                            </div>
                        </div>
                        <h4 style={styles.heading}>No Questions Available</h4>
                        <div style={styles.row}>
                            <p style={styles.text}>
                                We're sorry, but there are currently no Questions available for you to add. Please create some questions.
                            </p>
                        </div>
                    </Container>
                )}
            </Grid>
            <Modal open={openPreview} >
                <Box className={classes.modalBox}>
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton onClick={handlePreviewClose}>
                            <X />
                        </IconButton>
                    </Box>
                    <Box className={classes.modalContent}>
                        <PreviewQuestion question={previewData} />
                    </Box>
                </Box>
            </Modal>
            <Grid item xs={12} textAlign={'right'}>
                <Button size='large' variant="contained" onClick={handleClose} color="primary" placeholder={'Back'} />
            </Grid>
        </Grid>
    )
}

const styles = {
    container: {
        marginTop: '5rem'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    heading: {
        fontSize: '1.65rem',
        fontWeight: '500',
        marginTop: '1rem',
        marginBottom: '0',
        textAlign: 'center'
    },
    iconContainer: {
        backgroundColor: stormGrey[100],
        padding: '1rem',
        borderRadius: '50%',
        height: '40px',
        width: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        color: stormGrey[400],
        fontSize: '1rem',
        textAlign: 'center',
        width: '50%',
    }
}